<template>
  <div v-if="!localLoading">
    <template v-if="templates.length > 0">
      <FeatureAlertCard
        v-if="!account.careerPortal"
        class="mb-7"
      />
      <div class="design-choice">
        <div class="design-choice__title">
          {{ $t('designChoice') }}
        </div>
      </div>
      <div class="vimgs">
        <div class="vimgs__box col-lg-2 col-md-3 col-sm-5">
          <VImg
            v-if="locale === 'ru'"
            :src="require('@/assets/img/templates/base_template_image_ru.png')"
            :aspect-ratio="16 / 13"
          >
            <svg
              v-if="!company.companyTemplateSettings"
              style="position: absolute; top: 10px; right: 10px;"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="30"
                height="30"
                rx="15"
                fill="#1FC57F"
              />
              <path d="M12.2001 21.2833C11.9772 21.2834 11.7564 21.2396 11.5505 21.1542C11.3446 21.0689 11.1575 20.9438 11.0001 20.786L7.29272 17.0807L8.70739 15.6667L12.2001 19.1593L21.2927 10.0667L22.7074 11.4807L13.4001 20.786C13.2426 20.9438 13.0555 21.0689 12.8496 21.1542C12.6437 21.2396 12.423 21.2834 12.2001 21.2833Z" fill="white" />
            </svg>
          </VImg>
          <VImg
            v-if="locale === 'en'"
            :src="require('@/assets/img/templates/base_template_image_en.png')"
            :aspect-ratio="16 / 13"
          >
            <svg
              v-if="!company.companyTemplateSettings"
              style="position: absolute; top: 10px; right: 10px;"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="30"
                height="30"
                rx="15"
                fill="#1FC57F"
              />
              <path d="M12.2001 21.2833C11.9772 21.2834 11.7564 21.2396 11.5505 21.1542C11.3446 21.0689 11.1575 20.9438 11.0001 20.786L7.29272 17.0807L8.70739 15.6667L12.2001 19.1593L21.2927 10.0667L22.7074 11.4807L13.4001 20.786C13.2426 20.9438 13.0555 21.0689 12.8496 21.1542C12.6437 21.2396 12.423 21.2834 12.2001 21.2833Z" fill="white" />
            </svg>
          </VImg>

          <div class="button-wrap">
            <div class="v-btns__redacting mt-3 mb-2">
              <a
                style="text-decoration: none;"
                target="_blank"
                :href="`${frontendUrl}/company/${company.id}?preview=true`"
              >
                <VBtn border="1px solid #E0E0E0" width="100%" color="white">
                  <span class="v-btn__text">{{ $t('preview') }}</span>
                </VBtn>
              </a>
              <div class="v-btn__apply">
                <div class="v-btn__apply-btn" style="width: 100%">
                  <VBtn
                    width="100%"
                    color="next"
                    :disabled="!hasAppliedTemplate"
                    @click="loader(() => disableAllTemplates())"
                  >
                    {{ $t('publish') }}
                  </VBtn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vimgs__box col-lg-2 col-md-3 col-sm-5" v-for="template of templates" :key="template.id">
          <VImg
            position="top center"
            v-if="template.pictureUrl"
            :src="template.pictureUrl"
            :aspect-ratio="16 / 13"
          >
            <div class="vimgs__icons">
              <svg
                v-if="template.templateHasChanges"
                width="30"
                height="30"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="31"
                  height="31"
                  rx="15.5"
                  fill="white"
                />
                <g clip-path="url(#clip0_2468_2)">
                  <path d="M10.586 19.5595C10.2109 19.9345 10.0001 20.4431 10 20.9735V22H11.0265C11.5569 21.9999 12.0655 21.7891 12.4405 21.414L19.112 14.7425L17.2575 12.888L10.586 19.5595Z" fill="#212121" />
                  <path d="M21.5724 10.4275C21.4506 10.3056 21.306 10.2089 21.1469 10.143C20.9877 10.077 20.8171 10.043 20.6449 10.043C20.4726 10.043 20.302 10.077 20.1428 10.143C19.9837 10.2089 19.8391 10.3056 19.7174 10.4275L17.9644 12.181L19.8189 14.0355L21.5724 12.2825C21.6942 12.1607 21.7909 12.0162 21.8569 11.857C21.9229 11.6979 21.9568 11.5273 21.9568 11.355C21.9568 11.1827 21.9229 11.0121 21.8569 10.853C21.7909 10.6938 21.6942 10.5493 21.5724 10.4275Z" fill="#212121" />
                </g>
                <rect
                  x="0.5"
                  y="0.5"
                  width="31"
                  height="31"
                  rx="15.5"
                  stroke="#E0E0E0"
                />
                <defs>
                  <clipPath id="clip0_2468_2">
                    <rect
                      width="12"
                      height="12"
                      fill="white"
                      transform="translate(10 10)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <svg
                v-if="company.companyTemplateSettings && isCurrentTemplate(template)"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="30"
                  height="30"
                  rx="15"
                  fill="#1FC57F"
                />
                <path d="M12.2001 21.2833C11.9772 21.2834 11.7564 21.2396 11.5505 21.1542C11.3446 21.0689 11.1575 20.9438 11.0001 20.786L7.29272 17.0807L8.70739 15.6667L12.2001 19.1593L21.2927 10.0667L22.7074 11.4807L13.4001 20.786C13.2426 20.9438 13.0555 21.0689 12.8496 21.1542C12.6437 21.2396 12.423 21.2834 12.2001 21.2833Z" fill="white" />
              </svg>
            </div>
          </VImg>

          <div class="button-wrap">
            <div class="v-btn__preview">
              <a
                style="text-decoration: none;"
                :href="`${careerPortalUrl}preview/${template.name}/${company.id}`"
                target="_blank"
              >
                <VBtn border="1px solid #E0E0E0" width="100%" color="white">
                  <span class="v-btn__text">{{ $t('preview') }}</span>
                </VBtn>
              </a>
            </div>
            <div class="v-btns__redacting">
              <VBtn
                v-if="!template.companyId"
                color="next"
                class="btn__redacting"
                @click="loader(() => setRedactingAndRedirect(template.id, template.name))"
              >
                {{ $t('redacting') }}
              </VBtn>
              <template v-if="company.companyTemplateSettings && isCurrentTemplate(template)">
                <VBtn style="width: 100%" color="red" @click="loader(() => disableAllTemplates())">
                  {{ $t('cancel') }}
                </VBtn>
              </template>
              <template v-else>
                <VBtn width="100%" color="next" @click="applyTemplate(template)">
                  <div>
                    {{ $t('publish') }}
                  </div>
                </VBtn>
              </template>
            </div>
          </div>
        </div>
        <div class="vimgs__box-request col-lg-2 col-md-3 col-sm-5">
          <svg
            height="131"
            viewBox="0 0 208 131"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M78.4855 20.6276C78.3428 20.8117 78.1455 20.9459 77.9219 21.011C77.6983 21.0762 77.4599 21.069 77.2406 20.9905C77.1739 20.9708 77.1085 20.9469 77.0448 20.919C77.1167 20.1494 77.0811 19.3734 76.9388 18.6136C76.8829 19.2667 76.7232 19.9067 76.4656 20.5095C76.2557 20.299 76.0839 20.0537 75.9578 19.7844C75.7228 19.2273 75.5671 18.64 75.4952 18.0397C75.1477 15.9943 74.8047 13.8665 75.3718 11.8676C76.2026 8.94761 78.8222 6.84847 79.9164 4.01542L80.4555 3.53149C81.3782 5.10285 81.4191 7.05544 81.0429 8.83725C80.6688 10.6226 79.9148 12.2982 79.3187 14.0199C78.7226 15.7417 78.2761 17.573 78.5526 19.3746C78.6162 19.7988 78.7132 20.2651 78.4855 20.6276Z"
              fill="#2F2E41"
            />
            <path
              d="M66.5052 45.335L62.9922 61.4025L78.3363 66.4001L76.08 45.335H66.5052Z"
              fill="#FFB6B6"
            />
            <path
              d="M174.783 130.606H181.736V98.7284C181.727 90.5017 178.455 82.6146 172.638 76.7974C166.821 70.9802 158.934 67.7081 150.707 67.6987H86.0862C77.8595 67.7081 69.9724 70.9802 64.1552 76.7974C58.3381 82.6146 55.0659 90.5017 55.0566 98.7284V130.606H62.0098V108.828C62.0191 100.525 65.3217 92.5645 71.193 86.6932C77.0642 80.8219 85.0247 77.5193 93.3279 77.5099H143.465C151.768 77.5193 159.729 80.8219 165.6 86.6932C171.471 92.5645 174.774 100.525 174.783 108.828V130.606Z"
              fill="#E6E6E6"
            />
            <path
              d="M90.2902 113.929L82.8797 111.685C82.3978 109.705 82.1548 107.674 82.1558 105.636C82.1593 105.176 82.2938 104.726 82.5437 104.34C82.7935 103.953 83.1483 103.645 83.5665 103.453C83.9847 103.261 84.449 103.191 84.9052 103.253C85.3613 103.315 85.7904 103.506 86.1423 103.802C90.1168 107.211 95.9385 109.031 99.6955 112.915C101.25 114.548 102.418 116.51 103.112 118.655C103.806 120.8 104.008 123.074 103.703 125.308L105.325 130.554C101.695 130.292 98.1646 129.246 94.9775 127.489C91.7904 125.731 89.0222 123.303 86.8638 120.373C85.6692 118.716 84.6878 116.917 83.943 115.015C87.0859 114.659 90.2902 113.929 90.2902 113.929Z"
              fill="#F2F2F2"
            />
            <path
              d="M109.603 122.52L113.383 121.376C113.388 121.356 113.393 121.336 113.397 121.316C113.502 120.854 113.469 120.371 113.302 119.927C113.136 119.483 112.843 119.098 112.46 118.819C112.076 118.54 111.62 118.379 111.147 118.357C110.673 118.334 110.203 118.45 109.795 118.692C108.08 119.711 106.175 120.589 104.806 122.003C104.013 122.836 103.418 123.837 103.064 124.931C102.71 126.025 102.607 127.185 102.762 128.324L101.935 131C103.787 130.866 105.587 130.333 107.213 129.436C108.838 128.54 110.25 127.301 111.351 125.807C111.96 124.962 112.461 124.044 112.841 123.074C111.238 122.893 109.603 122.52 109.603 122.52Z"
              fill="#F2F2F2"
            />
            <path
              d="M140.199 44.1899H125.48C125.272 44.1903 125.072 44.2732 124.925 44.4207C124.778 44.5681 124.696 44.7679 124.696 44.9761V68.2268H140.985V44.9761C140.985 44.8728 140.964 44.7706 140.925 44.6752C140.885 44.5798 140.828 44.4931 140.755 44.4201C140.682 44.3471 140.595 44.2892 140.499 44.2497C140.404 44.2102 140.302 44.1899 140.199 44.1899ZM132.889 57.4007C132.429 57.3986 131.988 57.2148 131.662 56.8893C131.337 56.5638 131.153 56.123 131.151 55.6627V52.981C131.151 52.5204 131.335 52.0789 131.661 51.7535C131.987 51.428 132.428 51.2452 132.889 51.2452C133.349 51.2452 133.791 51.428 134.117 51.7535C134.443 52.0789 134.626 52.5204 134.627 52.981V55.6627C134.625 56.123 134.441 56.5638 134.115 56.8893C133.79 57.2148 133.349 57.3986 132.889 57.4007Z"
              fill="#3F3D56"
            />
            <path
              d="M164.571 7.90454H101.656C101.115 7.9054 100.597 8.12051 100.215 8.50273C99.8324 8.88495 99.6173 9.4031 99.6165 9.94364V52.3992C99.617 52.9399 99.832 53.4582 100.214 53.8405C100.597 54.2228 101.115 54.4378 101.656 54.4383H164.571C165.112 54.4378 165.63 54.2228 166.012 53.8405C166.395 53.4582 166.61 52.9399 166.61 52.3992V9.94364C166.609 9.40311 166.394 8.88495 166.012 8.50273C165.63 8.12051 165.112 7.9054 164.571 7.90454Z"
              fill="#3F3D56"
            />
            <path
              d="M164.046 9.37744H102.181C101.892 9.37807 101.614 9.49347 101.41 9.69834C101.205 9.90321 101.091 10.1808 101.091 10.4702V51.8735C101.091 52.1625 101.206 52.4396 101.411 52.644C101.615 52.8484 101.892 52.9635 102.181 52.964H164.046C164.335 52.9635 164.612 52.8484 164.816 52.644C165.021 52.4396 165.136 52.1625 165.136 51.8735V10.4702C165.136 10.1808 165.021 9.90321 164.817 9.69834C164.612 9.49348 164.335 9.37807 164.046 9.37744Z"
              fill="white"
            />
            <path
              d="M124.646 67.4832V69.7264C124.646 69.8426 124.692 69.954 124.774 70.0362C124.856 70.1184 124.968 70.1647 125.084 70.1649H140.597C140.713 70.1643 140.824 70.1179 140.906 70.0358C140.988 69.9537 141.035 69.8425 141.035 69.7264V67.4832H124.646Z"
              fill="#3F3D56"
            />
            <path
              d="M151.996 70.9454H115.19C115.089 70.9454 114.989 70.9229 114.898 70.8796C114.807 70.8363 114.727 70.7732 114.664 70.695C114.6 70.6167 114.555 70.5253 114.531 70.4274C114.508 70.3295 114.506 70.2275 114.527 70.1289L115.098 67.4165C115.131 67.2647 115.214 67.1287 115.335 67.0309C115.455 66.9331 115.605 66.8795 115.761 66.8789H151.425C151.58 66.8795 151.73 66.9331 151.851 67.0309C151.971 67.1287 152.055 67.2647 152.087 67.4165L152.658 70.1289C152.679 70.2275 152.677 70.3295 152.654 70.4274C152.63 70.5253 152.585 70.6167 152.521 70.695C152.458 70.7732 152.378 70.8363 152.287 70.8796C152.196 70.9229 152.096 70.9454 151.996 70.9454Z"
              fill="#3F3D56"
            />
            <path
              d="M117.014 67.3674H116.163C116.085 67.3674 116.022 67.4305 116.022 67.5083V67.9067C116.022 67.9845 116.085 68.0476 116.163 68.0476H117.014C117.092 68.0476 117.155 67.9845 117.155 67.9067V67.5083C117.155 67.4305 117.092 67.3674 117.014 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M119.282 67.3674H118.43C118.352 67.3674 118.289 67.4305 118.289 67.5083V67.9067C118.289 67.9845 118.352 68.0476 118.43 68.0476H119.282C119.36 68.0476 119.423 67.9845 119.423 67.9067V67.5083C119.423 67.4305 119.36 67.3674 119.282 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M121.549 67.3674H120.697C120.619 67.3674 120.556 67.4305 120.556 67.5083V67.9067C120.556 67.9845 120.619 68.0476 120.697 68.0476H121.549C121.627 68.0476 121.69 67.9845 121.69 67.9067V67.5083C121.69 67.4305 121.627 67.3674 121.549 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M123.816 67.3674H122.964C122.887 67.3674 122.823 67.4305 122.823 67.5083V67.9067C122.823 67.9845 122.887 68.0476 122.964 68.0476H123.816C123.894 68.0476 123.957 67.9845 123.957 67.9067V67.5083C123.957 67.4305 123.894 67.3674 123.816 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M126.083 67.3674H125.231C125.154 67.3674 125.091 67.4305 125.091 67.5083V67.9067C125.091 67.9845 125.154 68.0476 125.231 68.0476H126.083C126.161 68.0476 126.224 67.9845 126.224 67.9067V67.5083C126.224 67.4305 126.161 67.3674 126.083 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M128.35 67.3674H127.499C127.421 67.3674 127.358 67.4305 127.358 67.5083V67.9067C127.358 67.9845 127.421 68.0476 127.499 68.0476H128.35C128.428 68.0476 128.491 67.9845 128.491 67.9067V67.5083C128.491 67.4305 128.428 67.3674 128.35 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M130.618 67.3674H129.766C129.688 67.3674 129.625 67.4305 129.625 67.5083V67.9067C129.625 67.9845 129.688 68.0476 129.766 68.0476H130.618C130.696 68.0476 130.759 67.9845 130.759 67.9067V67.5083C130.759 67.4305 130.696 67.3674 130.618 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M132.885 67.3674H132.033C131.955 67.3674 131.892 67.4305 131.892 67.5083V67.9067C131.892 67.9845 131.955 68.0476 132.033 68.0476H132.885C132.963 68.0476 133.026 67.9845 133.026 67.9067V67.5083C133.026 67.4305 132.963 67.3674 132.885 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M135.152 67.3674H134.3C134.222 67.3674 134.159 67.4305 134.159 67.5083V67.9067C134.159 67.9845 134.222 68.0476 134.3 68.0476H135.152C135.23 68.0476 135.293 67.9845 135.293 67.9067V67.5083C135.293 67.4305 135.23 67.3674 135.152 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M137.419 67.3674H136.567C136.49 67.3674 136.427 67.4305 136.427 67.5083V67.9067C136.427 67.9845 136.49 68.0476 136.567 68.0476H137.419C137.497 68.0476 137.56 67.9845 137.56 67.9067V67.5083C137.56 67.4305 137.497 67.3674 137.419 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M139.686 67.3674H138.834C138.757 67.3674 138.694 67.4305 138.694 67.5083V67.9067C138.694 67.9845 138.757 68.0476 138.834 68.0476H139.686C139.764 68.0476 139.827 67.9845 139.827 67.9067V67.5083C139.827 67.4305 139.764 67.3674 139.686 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M141.954 67.3674H141.102C141.024 67.3674 140.961 67.4305 140.961 67.5083V67.9067C140.961 67.9845 141.024 68.0476 141.102 68.0476H141.954C142.031 68.0476 142.095 67.9845 142.095 67.9067V67.5083C142.095 67.4305 142.031 67.3674 141.954 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M144.221 67.3674H143.369C143.291 67.3674 143.228 67.4305 143.228 67.5083V67.9067C143.228 67.9845 143.291 68.0476 143.369 68.0476H144.221C144.299 68.0476 144.362 67.9845 144.362 67.9067V67.5083C144.362 67.4305 144.299 67.3674 144.221 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M146.488 67.3674H145.636C145.558 67.3674 145.495 67.4305 145.495 67.5083V67.9067C145.495 67.9845 145.558 68.0476 145.636 68.0476H146.488C146.566 68.0476 146.629 67.9845 146.629 67.9067V67.5083C146.629 67.4305 146.566 67.3674 146.488 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M148.755 67.3674H147.903C147.826 67.3674 147.762 67.4305 147.762 67.5083V67.9067C147.762 67.9845 147.826 68.0476 147.903 68.0476H148.755C148.833 68.0476 148.896 67.9845 148.896 67.9067V67.5083C148.896 67.4305 148.833 67.3674 148.755 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M151.022 67.3674H150.17C150.093 67.3674 150.03 67.4305 150.03 67.5083V67.9067C150.03 67.9845 150.093 68.0476 150.17 68.0476H151.022C151.1 68.0476 151.163 67.9845 151.163 67.9067V67.5083C151.163 67.4305 151.1 67.3674 151.022 67.3674Z"
              fill="#E6E6E6"
            />
            <path
              d="M116.988 68.501H116.136C116.058 68.501 115.995 68.564 115.995 68.6419V69.0403C115.995 69.1181 116.058 69.1811 116.136 69.1811H116.988C117.066 69.1811 117.129 69.1181 117.129 69.0403V68.6419C117.129 68.564 117.066 68.501 116.988 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M119.255 68.501H118.403C118.325 68.501 118.262 68.564 118.262 68.6419V69.0403C118.262 69.1181 118.325 69.1811 118.403 69.1811H119.255C119.333 69.1811 119.396 69.1181 119.396 69.0403V68.6419C119.396 68.564 119.333 68.501 119.255 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M121.522 68.501H120.67C120.592 68.501 120.529 68.564 120.529 68.6419V69.0403C120.529 69.1181 120.592 69.1811 120.67 69.1811H121.522C121.6 69.1811 121.663 69.1181 121.663 69.0403V68.6419C121.663 68.564 121.6 68.501 121.522 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M123.789 68.501H122.938C122.86 68.501 122.797 68.564 122.797 68.6419V69.0403C122.797 69.1181 122.86 69.1811 122.938 69.1811H123.789C123.867 69.1811 123.93 69.1181 123.93 69.0403V68.6419C123.93 68.564 123.867 68.501 123.789 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M126.056 68.501H125.205C125.127 68.501 125.064 68.564 125.064 68.6419V69.0403C125.064 69.1181 125.127 69.1811 125.205 69.1811H126.056C126.134 69.1811 126.197 69.1181 126.197 69.0403V68.6419C126.197 68.564 126.134 68.501 126.056 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M128.324 68.501H127.472C127.394 68.501 127.331 68.564 127.331 68.6419V69.0403C127.331 69.1181 127.394 69.1811 127.472 69.1811H128.324C128.401 69.1811 128.464 69.1181 128.464 69.0403V68.6419C128.464 68.564 128.401 68.501 128.324 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M130.591 68.501H129.739C129.661 68.501 129.598 68.564 129.598 68.6419V69.0403C129.598 69.1181 129.661 69.1811 129.739 69.1811H130.591C130.669 69.1811 130.732 69.1181 130.732 69.0403V68.6419C130.732 68.564 130.669 68.501 130.591 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M132.858 68.501H132.006C131.928 68.501 131.865 68.564 131.865 68.6419V69.0403C131.865 69.1181 131.928 69.1811 132.006 69.1811H132.858C132.936 69.1811 132.999 69.1181 132.999 69.0403V68.6419C132.999 68.564 132.936 68.501 132.858 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M135.125 68.501H134.273C134.196 68.501 134.133 68.564 134.133 68.6419V69.0403C134.133 69.1181 134.196 69.1811 134.273 69.1811H135.125C135.203 69.1811 135.266 69.1181 135.266 69.0403V68.6419C135.266 68.564 135.203 68.501 135.125 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M137.393 68.501H136.541C136.463 68.501 136.4 68.564 136.4 68.6419V69.0403C136.4 69.1181 136.463 69.1811 136.541 69.1811H137.393C137.47 69.1811 137.533 69.1181 137.533 69.0403V68.6419C137.533 68.564 137.47 68.501 137.393 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M139.66 68.501H138.808C138.73 68.501 138.667 68.564 138.667 68.6419V69.0403C138.667 69.1181 138.73 69.1811 138.808 69.1811H139.66C139.738 69.1811 139.801 69.1181 139.801 69.0403V68.6419C139.801 68.564 139.738 68.501 139.66 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M141.927 68.501H141.075C140.997 68.501 140.934 68.564 140.934 68.6419V69.0403C140.934 69.1181 140.997 69.1811 141.075 69.1811H141.927C142.005 69.1811 142.068 69.1181 142.068 69.0403V68.6419C142.068 68.564 142.005 68.501 141.927 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M144.194 68.501H143.342C143.264 68.501 143.201 68.564 143.201 68.6419V69.0403C143.201 69.1181 143.264 69.1811 143.342 69.1811H144.194C144.272 69.1811 144.335 69.1181 144.335 69.0403V68.6419C144.335 68.564 144.272 68.501 144.194 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M146.461 68.501H145.609C145.532 68.501 145.469 68.564 145.469 68.6419V69.0403C145.469 69.1181 145.532 69.1811 145.609 69.1811H146.461C146.539 69.1811 146.602 69.1181 146.602 69.0403V68.6419C146.602 68.564 146.539 68.501 146.461 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M148.728 68.501H147.876C147.799 68.501 147.736 68.564 147.736 68.6419V69.0403C147.736 69.1181 147.799 69.1811 147.876 69.1811H148.728C148.806 69.1811 148.869 69.1181 148.869 69.0403V68.6419C148.869 68.564 148.806 68.501 148.728 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M150.996 68.501H150.144C150.066 68.501 150.003 68.564 150.003 68.6419V69.0403C150.003 69.1181 150.066 69.1811 150.144 69.1811H150.996C151.073 69.1811 151.137 69.1181 151.137 69.0403V68.6419C151.137 68.564 151.073 68.501 150.996 68.501Z"
              fill="#E6E6E6"
            />
            <path
              d="M135.805 69.8613H127.018C126.941 69.8613 126.877 69.9244 126.877 70.0022V70.4006C126.877 70.4784 126.941 70.5415 127.018 70.5415H135.805C135.883 70.5415 135.946 70.4784 135.946 70.4006V70.0022C135.946 69.9244 135.883 69.8613 135.805 69.8613Z"
              fill="#E6E6E6"
            />
            <path
              d="M154.821 19.7709V41.5633C154.821 43.0227 154.241 44.4223 153.209 45.4542C152.177 46.4862 150.778 47.066 149.318 47.0662H122.043C120.97 47.0664 119.919 46.7527 119.021 46.1636C118.124 45.5745 117.418 44.7358 116.991 43.7506C116.848 43.4251 116.738 43.0856 116.665 42.7377C117.244 42.9621 117.861 43.0766 118.483 43.0754H145.758C147.102 43.0735 148.392 42.5384 149.343 41.5875C150.294 40.6365 150.829 39.3473 150.831 38.0024V16.21C150.832 15.5884 150.717 14.9719 150.493 14.3921C150.841 14.4658 151.18 14.5751 151.506 14.7182C152.491 15.1453 153.33 15.8512 153.919 16.749C154.508 17.6467 154.822 18.6971 154.821 19.7709Z"
              fill="#F2F2F2"
            />
            <path
              d="M53.066 106.475L50.3607 108.15L42.3909 98.3529L46.3834 95.8811L53.066 106.475Z"
              fill="#FFB6B6"
            />
            <path
              d="M55.4018 109.974L53.2256 110.945L51.92 109.064L51.8423 111.563L46.0706 114.139C45.794 114.263 45.4851 114.294 45.1891 114.23C44.893 114.165 44.6254 114.008 44.4251 113.781C44.2249 113.553 44.1026 113.268 44.076 112.966C44.0495 112.664 44.1201 112.362 44.2776 112.103L47.4657 106.862L46.5385 104.785L51.5156 102.91L55.4018 109.974Z"
              fill="#2F2E41"
            />
            <path
              d="M45.4877 104.59L50.0568 100.162C46.6622 91.7853 46.3909 86.5931 41.6849 76.462C52.8504 78.7457 60.833 78.6069 70.067 76.5594C73.1931 75.877 81.2591 69.6465 80.596 66.4519C80.565 66.3025 80.5284 66.1546 80.4861 66.0081C79.4949 62.6286 80.1929 57.4534 78.0475 53.7032C74.0784 52.2067 68.048 57.2599 63.3307 60.3402C61.0561 61.8254 62.7212 63.8494 61.0222 64.3801L54.5096 66.4941L38.5311 63.9135C37.7589 63.7964 36.9711 63.8334 36.2133 64.0222C35.4554 64.211 34.7424 64.548 34.1153 65.0136C33.4883 65.4793 32.9596 66.0644 32.5597 66.7353C32.1599 67.4062 31.8968 68.1497 31.7856 68.9227C31.7585 69.0962 31.7389 69.2707 31.7268 69.446C32.462 73.5158 33.2284 77.4787 34.0535 81.2406C34.3198 82.4549 33.8702 84.7829 34.8718 84.8175C35.8734 84.8521 35.4699 87.2599 35.7818 88.437C37.7022 95.6839 38.9165 99.191 45.4877 104.59Z"
              fill="#2F2E41"
            />
            <path
              d="M36.7427 124.011L33.9243 122.54L38.3835 110.727L42.5432 112.898L36.7427 124.011Z"
              fill="#FFB6B6"
            />
            <path
              d="M36.2729 115.192L40.7922 118.304C46.3311 110.293 49.9274 99.5892 52.6058 87.6121C63.034 83.0629 72.159 77.8583 78.5178 70.8773C79.5621 69.7069 80.1096 68.1759 80.0445 66.6087C79.9794 65.0415 79.3066 63.5612 78.1688 62.4815C78.0576 62.3772 77.9425 62.2773 77.8237 62.1817C75.0695 59.9878 68.9524 61.2502 65.0427 59.4165L58.0583 69.0833L58.8611 71.3348L56.4314 72.5177L54.3799 73.5163L52.0316 74.6596L44.3332 78.4072C43.6353 78.7561 43.0133 79.2397 42.5032 79.8301C41.9931 80.4205 41.6049 81.1061 41.3611 81.8473C41.1173 82.5885 41.0226 83.3706 41.0826 84.1486C41.1425 84.9266 41.3559 85.685 41.7105 86.38C41.7882 86.5374 41.8727 86.6913 41.9637 86.8417L39.1046 101.085C39.1046 101.085 39.8913 103.565 38.6534 103.333C37.4156 103.101 38.0901 106.139 38.0901 106.139L36.2729 115.192Z"
              fill="#2F2E41"
            />
            <path
              d="M35.036 130.521L32.9232 129.419L33.5872 127.227L31.5803 128.718L25.9769 125.793C25.7083 125.653 25.4915 125.431 25.3582 125.159C25.225 124.887 25.1821 124.579 25.236 124.281C25.2899 123.983 25.4377 123.71 25.6578 123.501C25.8779 123.293 26.1588 123.161 26.4595 123.124L32.5472 122.369L33.5996 120.352L38.1596 123.089L35.036 130.521Z"
              fill="#2F2E41"
            />
            <path
              d="M96.6378 68.5947L93.3415 60.6287L90.7444 62.0715L92.3128 70.175C92.1557 70.6884 92.1449 71.2354 92.2817 71.7545C92.4185 72.2737 92.6974 72.7444 93.087 73.1138C93.4766 73.4832 93.9616 73.7365 94.4873 73.8454C95.013 73.9543 95.5587 73.9143 96.0629 73.7301C96.5672 73.5458 97.0101 73.2245 97.3418 72.8024C97.6735 72.3802 97.8809 71.8739 97.9406 71.3404C98.0003 70.8068 97.91 70.2672 97.6798 69.7822C97.4497 69.2971 97.0888 68.8859 96.6378 68.5947Z"
              fill="#FFB6B6"
            />
            <path
              d="M41.3246 5.60223L46.3402 12.6142L48.5428 10.6205L45.1791 3.0831C45.2157 2.54748 45.1023 2.01225 44.8514 1.53758C44.6006 1.0629 44.2223 0.667609 43.7591 0.396136C43.2959 0.124664 42.7662 -0.0122261 42.2295 0.000857314C41.6928 0.0139407 41.1703 0.176478 40.7209 0.470197C40.2715 0.763915 39.9129 1.17717 39.6855 1.6635C39.4581 2.14983 39.3709 2.68996 39.4336 3.22316C39.4963 3.75636 39.7065 4.2615 40.0406 4.68178C40.3747 5.10206 40.8193 5.42082 41.3246 5.60223H41.3246Z"
              fill="#FFB6B6"
            />
            <path
              d="M63.9737 50.0451C60.7206 55.091 72.6387 66.0852 78.9132 63.5144C80.0119 63.0642 83.7912 61.5773 81.2079 59.5159C78.6246 57.4545 81.5074 59.7615 81.5755 58.4196C81.6211 57.5224 80.9265 55.5544 81.6512 55.6387C82.376 55.7231 82.7919 53.6271 81.2135 53.0932C80.6647 52.8972 80.1832 52.5488 79.8254 52.0888C79.4676 51.6287 79.2484 51.0763 79.1936 50.4961C79.0427 44.9653 80.9157 39.1909 80.9157 39.1909L88.562 58.7368C88.562 58.7368 88.5056 62.1183 89.4807 61.085C90.4557 60.0516 90.3848 63.3961 90.3848 63.3961C90.3848 63.3961 91.8347 64.408 91.0009 64.9712C90.1672 65.5343 91.8986 67.2657 91.8986 67.2657L95.9385 66.9771C95.9385 66.9771 95.8752 63.9761 95.1854 63.3124C94.4956 62.6487 94.8345 61.6044 94.8345 61.6044C94.8345 61.6044 93.4124 60.2815 94.2426 58.7237C95.0728 57.1659 88.1968 29.3013 88.1968 29.3013C87.9214 27.9607 87.2806 26.7223 86.3453 25.7232C85.41 24.724 84.2166 24.0029 82.8971 23.6396L78.5337 22.4382L77.7589 19.364H71.615L70.5448 21.384L60.7336 20.5183C60.7336 20.5183 51.0256 11.6854 51.4996 10.9957C51.9736 10.306 50.4687 8.69128 50.4687 8.69128C50.4687 8.69128 49.1834 8.27063 49.9087 8.04604C50.6339 7.82145 49.2631 7.30222 49.2631 7.30222C49.2631 7.30222 47.9935 6.96861 48.5923 6.52934C49.1911 6.09008 46.594 5.80151 46.594 5.80151L43.2244 8.55083L43.9054 9.70564C43.9054 9.70564 43.4902 11.2781 44.0321 10.7041C44.574 10.13 44.676 11.796 44.676 11.796C44.676 11.796 44.9528 13.6203 46.594 14.1699C48.2352 14.7195 49.4796 19.9412 49.4796 19.9412L63.3307 31.4837C61.2211 33.9051 61.7233 36.4372 63.592 39.0273L63.9737 50.0451Z"
              fill="#0A82D9"
            />
            <path
              d="M74.5483 17.3217C78.2227 17.3217 81.2014 14.3431 81.2014 10.6687C81.2014 6.9943 78.2227 4.01562 74.5483 4.01562C70.8739 4.01562 67.8953 6.9943 67.8953 10.6687C67.8953 14.3431 70.8739 17.3217 74.5483 17.3217Z"
              fill="#FFB6B6"
            />
            <path
              d="M80.3561 8.68714C80.1859 8.73619 77.6869 9.06227 76.6048 9.26427C75.5429 9.46338 75.3582 8.11001 74.4896 8.36395C74.4901 8.35803 74.4891 8.35209 74.4867 8.34663C74.3521 7.62955 74.1221 6.9337 73.8028 6.27763C73.9187 6.906 73.9352 7.54865 73.8519 8.18215C73.8514 8.19864 73.8495 8.21506 73.8461 8.23121C73.8433 8.26007 73.8375 8.28603 73.8346 8.31489C72.917 7.9109 72.3341 8.27161 71.6992 8.39857C70.9894 8.53997 70.4353 8.85162 70.8335 11.2842C71.6502 16.2879 75.8978 18.0741 75.162 21.384C75.0177 22.039 74.6541 22.8585 74.1982 23.0634C74.0635 22.3463 73.8335 21.6505 73.5143 20.9944C73.6301 21.6228 73.6467 22.2654 73.5634 22.8989C72.8564 22.1342 72.3456 19.4621 69.9679 17.3441C69.3821 16.8246 66.4474 13.7428 66.0953 13.0156C66.2034 13.597 66.2555 14.1874 66.2512 14.7787C66.2518 15.1745 66.2248 15.5698 66.1704 15.9618C66.1703 15.9871 66.1674 16.0123 66.1617 16.0369C66.1588 16.083 66.1501 16.1234 66.1444 16.1667C66.1386 16.2158 66.13 16.262 66.1213 16.311C65.1604 16.1725 64.3091 16.0051 63.908 15.6127C61.9573 13.7139 64.338 10.0145 65.6394 6.66719C67.5006 1.87414 72.9054 1.23641 73.4306 1.18447C75.7449 0.950732 79.655 1.44706 80.9333 4.07011C81.8278 5.90826 81.2565 8.42742 80.3561 8.68714Z"
              fill="#2F2E41"
            />
            <path
              d="M66.3274 9.7691L71.1468 2.27212C69.9917 1.60162 68.6766 1.25662 67.3412 1.27381C66.6756 1.28764 66.0205 1.44156 65.4184 1.72553C64.8164 2.0095 64.2809 2.41716 63.8469 2.92192C62.8626 4.1452 62.6937 5.87445 63.0625 7.40063C63.1899 7.92773 65.6152 6.07313 65.038 6.93882C64.5643 7.61661 63.7895 10.4655 63.5952 11.2673C63.2825 12.5577 62.4227 13.8823 63.1886 14.9668C64.0944 16.2493 65.7106 16.8868 67.2794 16.9516C68.8482 17.0163 70.3923 16.5816 71.8832 16.0891L66.3274 9.7691Z"
              fill="#2F2E41"
            />
            <path
              d="M68.1794 9.4735C68.1098 9.47341 68.0426 9.44819 67.9901 9.40247C67.9376 9.35674 67.9035 9.2936 67.8939 9.22467C67.8843 9.15574 67.8999 9.08567 67.9379 9.02736C67.9759 8.96905 68.0337 8.92644 68.1006 8.90736C68.1763 8.78252 68.1453 8.2571 68.1203 7.83257C68.0265 6.23856 67.8694 3.57077 70.4594 1.7699C70.5222 1.72622 70.5998 1.70928 70.6752 1.72281C70.7505 1.73634 70.8173 1.77923 70.861 1.84205C70.9047 1.90486 70.9216 1.98246 70.9081 2.05777C70.8946 2.13308 70.8517 2.19993 70.7889 2.24361C68.4646 3.85988 68.6041 6.23025 68.6965 7.79861C68.7492 8.6953 68.7874 9.34301 68.2435 9.46631C68.2225 9.47111 68.2009 9.47352 68.1794 9.4735Z"
              fill="#0A82D9"
            />
            <path
              d="M1.51334e-06 130.419C-0.000268282 130.51 0.0355459 130.597 0.0995609 130.661C0.163576 130.726 0.250549 130.762 0.341351 130.762H206.75C206.842 130.762 206.929 130.726 206.993 130.662C207.058 130.597 207.094 130.51 207.094 130.419C207.094 130.328 207.058 130.24 206.993 130.176C206.929 130.112 206.842 130.075 206.75 130.075H0.343402C0.29844 130.075 0.253894 130.084 0.212303 130.101C0.170713 130.118 0.132892 130.143 0.101005 130.175C0.0691182 130.207 0.0437886 130.244 0.02646 130.286C0.00913137 130.327 0.000142377 130.372 1.03196e-05 130.417L1.51334e-06 130.419Z"
              fill="#CCCCCC"
            />
            <path
              d="M127.7 27.3723H123.333C123.217 27.3723 123.106 27.3263 123.024 27.2444C122.942 27.1626 122.896 27.0515 122.896 26.9357C122.896 26.8199 122.942 26.7088 123.024 26.6269C123.106 26.545 123.217 26.499 123.333 26.499H127.7C127.816 26.499 127.927 26.545 128.008 26.6269C128.09 26.7088 128.136 26.8199 128.136 26.9357C128.136 27.0515 128.09 27.1626 128.008 27.2444C127.927 27.3263 127.816 27.3723 127.7 27.3723Z"
              fill="#0A82D9"
            />
            <path
              d="M135.56 27.3723H131.193C131.136 27.3723 131.079 27.361 131.026 27.3391C130.973 27.3172 130.925 27.285 130.884 27.2444C130.844 27.2039 130.812 27.1558 130.79 27.1028C130.768 27.0498 130.756 26.993 130.756 26.9357C130.756 26.8783 130.768 26.8216 130.79 26.7686C130.812 26.7156 130.844 26.6675 130.884 26.6269C130.925 26.5864 130.973 26.5542 131.026 26.5323C131.079 26.5103 131.136 26.499 131.193 26.499H135.56C135.617 26.499 135.674 26.5103 135.727 26.5323C135.78 26.5542 135.828 26.5864 135.868 26.6269C135.909 26.6675 135.941 26.7156 135.963 26.7686C135.985 26.8216 135.996 26.8783 135.996 26.9357C135.996 26.993 135.985 27.0498 135.963 27.1028C135.941 27.1558 135.909 27.2039 135.868 27.2444C135.828 27.285 135.78 27.3172 135.727 27.3391C135.674 27.361 135.617 27.3723 135.56 27.3723Z"
              fill="#0A82D9"
            />
            <path
              d="M139.49 30.8655H135.123C135.066 30.8655 135.009 30.8542 134.956 30.8323C134.903 30.8103 134.855 30.7782 134.814 30.7376C134.774 30.6971 134.741 30.6489 134.72 30.5959C134.698 30.543 134.686 30.4862 134.686 30.4288C134.686 30.3715 134.698 30.3147 134.72 30.2617C134.741 30.2088 134.774 30.1606 134.814 30.1201C134.855 30.0795 134.903 30.0474 134.956 30.0254C135.009 30.0035 135.066 29.9922 135.123 29.9922H139.49C139.547 29.9922 139.604 30.0035 139.657 30.0254C139.71 30.0474 139.758 30.0795 139.798 30.1201C139.839 30.1606 139.871 30.2088 139.893 30.2617C139.915 30.3147 139.926 30.3715 139.926 30.4288C139.926 30.4862 139.915 30.543 139.893 30.5959C139.871 30.6489 139.839 30.6971 139.798 30.7376C139.758 30.7782 139.71 30.8103 139.657 30.8323C139.604 30.8542 139.547 30.8655 139.49 30.8655Z"
              fill="#0A82D9"
            />
            <path
              d="M131.654 30.8655H123.333C123.217 30.8655 123.106 30.8195 123.024 30.7376C122.942 30.6557 122.896 30.5447 122.896 30.4288C122.896 30.313 122.942 30.202 123.024 30.1201C123.106 30.0382 123.217 29.9922 123.333 29.9922H131.654C131.77 29.9922 131.881 30.0382 131.962 30.1201C132.044 30.202 132.09 30.313 132.09 30.4288C132.09 30.5447 132.044 30.6557 131.962 30.7376C131.881 30.8195 131.77 30.8655 131.654 30.8655Z"
              fill="#0A82D9"
            />
            <path
              d="M147.373 27.3723H139.053C138.937 27.3723 138.826 27.3263 138.744 27.2444C138.662 27.1626 138.616 27.0515 138.616 26.9357C138.616 26.8199 138.662 26.7088 138.744 26.6269C138.826 26.545 138.937 26.499 139.053 26.499H147.373C147.431 26.499 147.488 26.5103 147.541 26.5323C147.594 26.5542 147.642 26.5864 147.682 26.6269C147.723 26.6675 147.755 26.7156 147.777 26.7686C147.799 26.8216 147.81 26.8783 147.81 26.9357C147.81 26.993 147.799 27.0498 147.777 27.1028C147.755 27.1558 147.723 27.2039 147.682 27.2444C147.642 27.285 147.594 27.3172 147.541 27.3391C147.488 27.361 147.431 27.3723 147.373 27.3723Z"
              fill="#0A82D9"
            />
            <path
              d="M130.689 20.7574H122.369C122.311 20.7575 122.254 20.7463 122.201 20.7244C122.148 20.7026 122.1 20.6704 122.059 20.6299C122.019 20.5893 121.986 20.5411 121.964 20.4881C121.942 20.435 121.931 20.3781 121.931 20.3207C121.931 20.2633 121.942 20.2064 121.964 20.1533C121.986 20.1003 122.019 20.0521 122.059 20.0115C122.1 19.971 122.148 19.9388 122.201 19.917C122.254 19.8951 122.311 19.8839 122.369 19.884H130.689C130.805 19.884 130.916 19.93 130.998 20.0119C131.08 20.0938 131.126 20.2049 131.126 20.3207C131.126 20.4365 131.08 20.5476 130.998 20.6295C130.916 20.7113 130.805 20.7574 130.689 20.7574Z"
              fill="#0A82D9"
            />
            <path
              d="M131.373 23.3082C131.292 23.3083 131.212 23.2829 131.146 23.2355C131.079 23.1882 131.03 23.1213 131.003 23.0442C130.977 22.9671 130.975 22.8836 130.998 22.8055C131.022 22.7274 131.069 22.6585 131.133 22.6085L133.264 20.9524C133.349 20.8858 133.42 20.8022 133.472 20.7069C133.523 20.6115 133.554 20.5065 133.563 20.3984C133.572 20.2903 133.559 20.1816 133.523 20.0791C133.488 19.9766 133.432 19.8825 133.358 19.8028L131.569 17.8664C131.535 17.8287 131.508 17.7845 131.49 17.7363C131.472 17.6881 131.464 17.6369 131.466 17.5856C131.468 17.5343 131.48 17.4839 131.502 17.4372C131.523 17.3906 131.554 17.3487 131.591 17.3138C131.629 17.279 131.673 17.2519 131.721 17.2341C131.77 17.2164 131.821 17.2082 131.872 17.2103C131.923 17.2123 131.974 17.2244 132.02 17.2459C132.067 17.2674 132.109 17.2979 132.144 17.3356L134.8 20.2111C134.837 20.2509 134.865 20.2978 134.883 20.349C134.9 20.4002 134.907 20.4545 134.903 20.5085C134.898 20.5625 134.883 20.615 134.857 20.6626C134.831 20.7102 134.796 20.752 134.753 20.7852L131.613 23.226C131.544 23.2793 131.46 23.3083 131.373 23.3082Z"
              fill="#0A82D9"
            />
            <path
              d="M121.948 23.3082C122.029 23.3083 122.109 23.2829 122.175 23.2355C122.241 23.1882 122.291 23.1213 122.318 23.0442C122.344 22.9671 122.346 22.8836 122.322 22.8055C122.299 22.7274 122.252 22.6585 122.188 22.6085L120.057 20.9524C119.972 20.8858 119.901 20.8022 119.849 20.7069C119.797 20.6115 119.766 20.5065 119.757 20.3984C119.748 20.2903 119.762 20.1816 119.797 20.0791C119.833 19.9766 119.889 19.8825 119.963 19.8028L121.751 17.8664C121.786 17.8287 121.813 17.7845 121.831 17.7363C121.849 17.6881 121.857 17.6369 121.855 17.5856C121.853 17.5343 121.841 17.4839 121.819 17.4372C121.798 17.3906 121.767 17.3487 121.729 17.3138C121.692 17.279 121.648 17.2519 121.599 17.2341C121.551 17.2164 121.5 17.2082 121.449 17.2103C121.397 17.2123 121.347 17.2244 121.3 17.2459C121.254 17.2674 121.212 17.2979 121.177 17.3356L118.521 20.2111C118.484 20.2509 118.456 20.2978 118.438 20.349C118.42 20.4002 118.414 20.4545 118.418 20.5085C118.422 20.5625 118.438 20.615 118.464 20.6626C118.49 20.7102 118.525 20.752 118.568 20.7852L121.708 23.226C121.776 23.2793 121.861 23.3083 121.948 23.3082Z"
              fill="#0A82D9"
            />
            <path
              d="M134.991 38.3538H126.67C126.554 38.3538 126.443 38.3078 126.361 38.2259C126.279 38.144 126.233 38.0329 126.233 37.9171C126.233 37.8013 126.279 37.6903 126.361 37.6084C126.443 37.5265 126.554 37.4805 126.67 37.4805H134.991C135.106 37.4805 135.218 37.5265 135.299 37.6084C135.381 37.6903 135.427 37.8013 135.427 37.9171C135.427 38.0329 135.381 38.144 135.299 38.2259C135.218 38.3078 135.106 38.3538 134.991 38.3538Z"
              fill="#0A82D9"
            />
            <path
              d="M136.457 40.514C136.375 40.5141 136.296 40.4887 136.229 40.4413C136.163 40.394 136.113 40.3271 136.087 40.25C136.06 40.1729 136.058 40.0894 136.082 40.0113C136.105 39.9332 136.152 39.8643 136.216 39.8143L138.347 38.1582C138.433 38.0916 138.503 38.008 138.555 37.9127C138.607 37.8173 138.638 37.7123 138.647 37.6042C138.656 37.4961 138.642 37.3874 138.607 37.2849C138.571 37.1824 138.515 37.0883 138.442 37.0086L136.653 35.0722C136.618 35.0345 136.591 34.9903 136.573 34.9421C136.555 34.8939 136.547 34.8427 136.549 34.7914C136.551 34.7401 136.564 34.6897 136.585 34.6431C136.607 34.5964 136.637 34.5545 136.675 34.5196C136.712 34.4848 136.757 34.4577 136.805 34.4399C136.853 34.4222 136.904 34.4141 136.956 34.4161C137.007 34.4181 137.057 34.4302 137.104 34.4517C137.151 34.4732 137.192 34.5037 137.227 34.5414L139.884 37.4169C139.92 37.4567 139.948 37.5036 139.966 37.5548C139.984 37.606 139.991 37.6603 139.986 37.7143C139.982 37.7683 139.966 37.8208 139.94 37.8684C139.915 37.916 139.879 37.9578 139.836 37.991L136.697 40.4318C136.628 40.4851 136.544 40.5141 136.457 40.514Z"
              fill="#0A82D9"
            />
            <path
              d="M121.948 40.514C122.029 40.5141 122.109 40.4887 122.175 40.4413C122.241 40.394 122.291 40.3271 122.318 40.25C122.344 40.1729 122.346 40.0894 122.322 40.0113C122.299 39.9332 122.252 39.8643 122.188 39.8143L120.057 38.1582C119.972 38.0916 119.901 38.008 119.849 37.9127C119.797 37.8173 119.766 37.7123 119.757 37.6042C119.748 37.4961 119.762 37.3874 119.797 37.2849C119.833 37.1824 119.889 37.0883 119.963 37.0086L121.751 35.0722C121.822 34.996 121.859 34.895 121.855 34.7914C121.851 34.6878 121.806 34.59 121.729 34.5196C121.653 34.4492 121.552 34.412 121.449 34.4161C121.345 34.4202 121.247 34.4652 121.177 34.5414L118.521 37.4169C118.484 37.4567 118.456 37.5036 118.438 37.5548C118.42 37.606 118.414 37.6603 118.418 37.7143C118.422 37.7683 118.438 37.8208 118.464 37.8684C118.49 37.916 118.525 37.9578 118.568 37.991L121.708 40.4318C121.776 40.4851 121.861 40.5141 121.948 40.514Z"
              fill="#0A82D9"
            />
            <path
              d="M122.69 39.2905L124.439 35.2895C124.486 35.1839 124.572 35.1011 124.68 35.0593C124.788 35.0174 124.907 35.0199 125.013 35.0661C125.119 35.1124 125.202 35.1986 125.245 35.306C125.287 35.4135 125.285 35.5333 125.239 35.6393L123.49 39.6403C123.467 39.6931 123.434 39.7409 123.393 39.7809C123.352 39.8209 123.303 39.8524 123.249 39.8735C123.196 39.8946 123.139 39.9049 123.081 39.9039C123.024 39.9028 122.967 39.8904 122.914 39.8674C122.862 39.8444 122.814 39.8111 122.774 39.7696C122.734 39.7281 122.703 39.6792 122.682 39.6256C122.661 39.572 122.651 39.5148 122.653 39.4572C122.654 39.3997 122.667 39.3431 122.69 39.2905Z"
              fill="#0A82D9"
            />
          </svg>
          <div class="vimgs__box-text">
            {{ $t('developIndividualTemplate') }}
          </div>
          <div class="vimgs__box-link">
            <a :href="`mailto:${supportEmail}?subject=${$t('customizedTemplate')}`">
              {{ supportEmail }}
            </a>
          </div>
        </div>
      </div>
    </template>
    <VDialog v-model="dialogTariffPlan" persistent max-width="500">
      <VCard>
        <DialogTariffChange :title="$t('career-portal-na')" @close="cancelDialogTariffPlan" />
      </VCard>
    </VDialog>
    <VDialog v-model="dialogMakeChanges" persistent max-width="500">
      <VCard>
        <DialogTariffChange :title="$t('youMadeNoChanges')" @close="cancelDialogMakeChanges">
          <template v-slot:btn>
            <VBtn
              color="success"
              style="padding: 10px 50px; margin: 8px auto 8px;"
              id="inviteBtn"
              @click="cancelDialogMakeChanges"
            >
              {{ $t('ok') }}
            </VBtn>
          </template>
        </DialogTariffChange>
      </VCard>
    </VDialog>
  </div>
</template>

<script>
import useCompany from '@/compositions/useCompany';
import { computed, ref, toRefs } from '@vue/composition-api';
import { useI18n } from 'vue-i18n-composable';
import DialogTariffChange from '../DialogTariffChange.vue';
import FeatureAlertCard from './FeatureAlertCard.vue';
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'CareerPortalForm',
  components: {
    DialogTariffChange,
    FeatureAlertCard,
  },
  props: {
    loader: {
      type: Function,
      required: true,
    },
    localLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    account: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { account } = toRefs(props);

    const { locale } = useI18n();

    const {
      templates, company, applyTemplate: applyTemplateFunc,
    } = useCompany();

    const loadingAccount = ref(false);

    const dialogTariffPlan = ref(false);
    const dialogMakeChanges = ref(false);

    const { setRedacting, disableAllTemplates } = useCompany();

    function isCurrentTemplate(template) {
      return template.id === company?.value?.companyTemplateSettings?.templateId;
    }

    const hasAppliedTemplate = computed(() => !!company?.value?.companyTemplateSettings);

    const careerPortalUrl = ref(process.env.VUE_APP_CAREER_PORTAL_URL);
    const frontendUrl = ref(process.env.VUE_APP_FRONT_URL);

    async function applyTemplate(template) {
      if (!account.value.careerPortal && !template.companyId) {
        dialogTariffPlan.value = true;
        return;
      }

      if (!template.templateHasChanges && account.value.careerPortal && !template.companyId) {
        dialogMakeChanges.value = true;
        return;
      }

      await applyTemplateFunc(company.value.id, {
        templateId: template.id,
      });
    }

    async function setRedactingAndRedirect(templateId, templateName) {
      await setRedacting(templateId);
      window.location.href = `${careerPortalUrl.value}redacting/${templateName}/${company.value.id}`;
    }

    function cancelDialogTariffPlan() {
      dialogTariffPlan.value = false;
    }

    function cancelDialogMakeChanges() {
      dialogMakeChanges.value = false;
    }

    return {
      locale,
      templates,
      isCurrentTemplate,
      applyTemplate,
      careerPortalUrl,
      hasAppliedTemplate,
      setRedactingAndRedirect,
      disableAllTemplates,
      company,
      frontendUrl,
      dialogTariffPlan,
      dialogMakeChanges,
      cancelDialogTariffPlan,
      cancelDialogMakeChanges,
      loadingAccount,
      supportEmail: SUPPORT_EMAIL,
    };
  },
};
</script>

<style lang="scss" scoped>
.vimgs {
  display: flex;
  flex-wrap: wrap;
  &__box {
    margin-right: 40px;
    margin-bottom: 2rem;
    border-radius: 10px;
    padding: 0;
    border: 1px solid #E0E0E0;
    @media screen and (max-width: 1024px) {
      margin-right: 30px;
    }
    @media screen and (max-width: 600px) {
      height: 100%;
      margin-right: 0;
    }
    .v-image {
      border-bottom: 1px solid #E0E0E0;
    }
  }

  &__box-request {
    border: 1px solid #E0E0E0;
    border-radius: 10px;
    border-radius: 4px;
    padding: 100px 10px 18px 10px;
    height: 481px;
    svg {
      width: 100%;
    }
    @media screen and (max-width: 600px) {
      width: 100%;
      text-align: center;
    }
  }

  &__box-text {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: #000000;
    margin-bottom: 72px;
    margin-top: 52px;
    max-width: 233px;
    @media screen and (max-width: 600px) {
      margin: 52px auto 72px;
    }
  }
  &__box-link {
    display: block;
    text-align: center;
  }
  &__icons {
    position: absolute;
    right: 10px;
    top: 10px;
    svg:nth-child(2) {
      margin-left: 8px;
    }
  }
}

.v-btn__text {
  color: #757575;
}

.button-wrap {
  padding: 10px;
}
.v-responsive {
  height: 300px !important;
  @media screen and (max-width: 600px) {
    height: 100% !important;
  }
}

.design-choice {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  &__title {
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 20px;
    color: #212121;
  }
}

.v-btn__preview {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.v-btn__apply {
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-btns__redacting {
  text-align: center;
  margin-bottom: 10px;
}

.btn__redacting {
  margin-bottom: 10px;
  width: 100%;
}

.v-btn__apply-btn {
  margin-top: 58px;
}

.btn__box-request {
  margin-bottom: 10px;
}

// .v-btn--blue:hover, .v-btn--white:hover, .v-btn--gray:hover {
//   opacity: 0.8;
// }
</style>

<i18n lang="yml" locale="en">
alreadyApplied: Applied
publish: Publish
customizedTemplate: Customized pattern
developIndividualTemplate: We will develop an individual template for your brand
preview: Preview
redacting: Edit
cancel: Cancel
designChoice: Choose the template
ok: Ok
career-portal-na: Career portal is unavailable with your plan
youMadeNoChanges: You made no changes
toUpgradePlan: Upgrade plan.
</i18n>

<i18n lang="yml" locale="ru">
alreadyApplied: Применено
publish: Опубликовать
customizedTemplate: Индивидуальный шаблон
developIndividualTemplate: Разработаем индивидуальный шаблон для вашего бренда
preview: Предпросмотр
redacting: Редактировать
cancel: Отменить
designChoice: Выбор дизайна
ok: Ок
career-portal-na: Карьерный портал недоступен на вашем тарифе
youMadeNoChanges: Вы не внесли изменения в шаблон
toUpgradePlan: Повысить тариф.
</i18n>
